import styled from "styled-components";
import logo from "../../images/logo.png";
import pfp from "../../images/pfp.png";

export const Wrapper = styled.div`
    background: var(--black);
    background-size: 100%, cover;
    background-position: center;
    positions: absolute;
    margin: 0 auto;
`;

export const Image = styled.div`
    background: url(${pfp}) no-repeat center;
    position: static;
    display: block;
    margin: auto;
    margin-top: 100px;
    width: 50%;
    height: 200px;
    background-size: contain;
    .caption {
        display: block;
    }
`;

export const Logo = styled.div`
    background: url(${logo}) no-repeat;
    position: absolute;
    top: 0;
    left: 0;
    margin-left: auto;
    margin-right: auto;
    width: 50%;
    height: 10%;
    background-size: contain; 
`;

export const ImageDescription = styled.div`
    font-family: 'Dotimatrix5', cursive;
    color: white;
    font-size: 1.5rem;
    a{
        text-decoration: none;
        color: white;
    }

    a:visited{
        text-decoration: none;
    }

    text-align: center;
`;


export const ParagraphText = styled.div`
    @import url('https://fonts.googleapis.com/css2?family=PT+Sans+Narrow&display=swap');
    font-size: var(--fontMed);
    color: var(--white);
    position: center;
    font-family: 'PT Sans Narrow', sans-serif;

    a{
        text-decoration: none;
        color: white;
    }

    a:visited{
        text-decoration: none;
    }

    p{
       text-align: justify;
       margin: 2.3rem;
    }

    ul{
        position:center;
        text-align: justify;
        margin: 0 auto;
        width: 50rem;
    }

    @media (max-width: 768px){
        ul{
            width: 20rem;
        }
    }

    @media (max-width: 200px){
        *{
            width: 10rem;
        }
    }

`;



